import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, from, map, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpRequestPayload } from '@core/models';
// import { AuthService } from 'src/app/core/services/auth/auth.service';
import { HttpRequest } from '../../models/http-provider.model';
import { AuthService } from '@fpx/core/services';
import { CommonService } from 'src/app/common.service';
import { UserService } from 'src/app/user.service';
import { HTTP } from '@ionic-native/http/ngx';
import { MobileService } from 'src/app/mobile.services';

declare let cordova: any;

@Injectable({
  providedIn: 'root',
})
export class HttpProviderService {
  // baseURL: string = 'http://10.11.12.46:10452';
  defaultContext = '/olive/publisher';
  fileUploadURL: string = '';
  keycloakURL: string = '';
  realm: string = '';
  client: string = '';
  restURL: string = '';
  idleTimeout: number = 0;
  idleTimer: any;
  idleTimeCount: number = 0;
  promptIdleTimeoutB4: number = 30; //in second
  isPromptTimerAlert: boolean = false;
  defaultIdleTimeout: number = 5;

  constructor(
    private httpClient: HttpClient,
    private _authService: AuthService,
    private _commonService: CommonService,
    private _userService: UserService,
    private secureHTTP: HTTP,
    private mobileService: MobileService
  ) {
    // this._getConfig();
  }

  invokeApi(request: HttpRequestPayload): Observable<any> {
    let requestURL = this.getBaseURL();
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL += request.queryParams ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      'authorization': this.authToken,
      'deviceInfo': this._commonService.encodedDeviceDetails,
      'languageId': environment.languageId
    };

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }
  invokeGoogleMapApi(request: HttpRequestPayload, showSpinner = true): Observable<any> {
    let requestURL = environment.googleMapApiURL;
    requestURL += request.resource + "&key=" + environment.googleMapVariable;
    requestURL = encodeURI(requestURL);
    return this.httpClient.get(requestURL);
  }

  invokeRestApi(httpRequest: HttpRequest, httpOption: Map<any, Map<string, any>> = new Map()): Observable<any> {
    let request = httpRequest.httpPayload;
    let requestURL = '';
    if (request.baseURl) {
      requestURL = request.baseURl;
    } else {
      requestURL += this.getBaseURL()
    }
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the path params */
    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(
          `{${request.pathParams[index].key}}`,
          request.pathParams[index].value
        );
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL +=
        request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
      'languageId': environment.languageId
    };
    
    if(this._commonService.encodedDeviceDetails) {
      headers['deviceInfo'] = this._commonService.encodedDeviceDetails;
    }

    /** append the header params  */
    let isMultipart:boolean = false;
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        if (param.key == 'Content-Type') {
          delete headers['Content-Type'];
          isMultipart = true;
        } 
        else headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any } = {
      headers: new HttpHeaders(headers),
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);

    if (this.mobileService.isHybrid() && this.mobileService.doEnableSecureHTTP) {
      return this.sendSecureHTTPRequest(requestURL, request.method, request.body, headers, isMultipart);
    } else {
      try {
        switch (request.method) {
          case 'POST':
            return this.httpClient.post(requestURL, request.body, httpOpts);
          case 'GET':
            return this.httpClient.get(requestURL, httpOpts);
          case 'PUT':
            return this.httpClient.put(requestURL, request.body, httpOpts);
          case 'DELETE':
            return this.httpClient.delete(requestURL, httpOpts);
          default:
            return throwError('METHOD NOT DEFINED');
        }
      } catch (error) {
        return throwError(error);
      }
    }
  }

  invokeUploadApi(httpRequest: HttpRequest): Observable<any> {
    let request = httpRequest.httpPayload;
    let requestURL = '';
    if (request.baseURl) {
      requestURL = request.baseURl;
    } else {
      requestURL += this.getBaseURL()
    }
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the path params */
    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(
          `{${request.pathParams[index].key}}`,
          request.pathParams[index].value
        );
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL +=
        request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {
      'Content-Type': 'application/json',
      authorization: this.authToken,
      'languageId': environment.languageId
    };

    if(this._commonService.encodedDeviceDetails){
      headers['deviceInfo'] = this._commonService.encodedDeviceDetails;
    }

    // if (request.isAuthTokenRequired) {
    //   headers['authorization'] = this.authToken;
    // }

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        if (param.key == 'Content-Type') delete headers['Content-Type'];
        else headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any, reportProgress: boolean } = {
      headers: new HttpHeaders(headers),
      reportProgress: true,
      observe: 'events'
    };
    requestURL = encodeURI(requestURL);

    try {
      switch (request.method) {
        case 'POST':
          return this.httpClient.post(requestURL, request.body, httpOpts);
        case 'GET':
          return this.httpClient.get(requestURL, httpOpts);
        case 'PUT':
          return this.httpClient.put(requestURL, request.body, httpOpts);
        case 'DELETE':
          return this.httpClient.delete(requestURL, httpOpts);
        default:
          return throwError('METHOD NOT DEFINED');
      }
    } catch (error) {
      return throwError(error);
    }
  }

  invokeDownloadApi(httpRequest: HttpRequest): Observable<any> {
    let request = httpRequest.httpPayload;
    let requestURL = '';
    if (request.baseURl) {
      requestURL = request.baseURl;
    } else {
      requestURL += this.getBaseURL();
    }
    requestURL += request.serverContext
      ? request.serverContext
      : this.getDefaultContext();

    requestURL += request.resource;

    /** append the path params */
    if (request.pathParams && request.pathParams.length > 0) {
      for (let index = 0; index < request.pathParams.length; index++) {
        requestURL = requestURL.replace(
          `{${request.pathParams[index].key}}`,
          request.pathParams[index].value
        );
      }
    }

    /** append the query params */
    if (request.queryParams && request.queryParams.length > 0) {
      requestURL += '?';
      for (let key in request.queryParams) {
        let value = request.queryParams[key];
        if (value) {
          requestURL += `${value.key}=${value.value}&`;
        }
      }
      requestURL = requestURL.substring(0, requestURL.length - 1);
    }
    /** append the filter criteria */
    if (request.filterCriteria) {
      requestURL +=
        request.queryParams && request.queryParams?.length > 0 ? '&' : '?';
      requestURL += `criteriaDetails=${JSON.stringify(request.filterCriteria)}`;
    }

    let headers: any = {};

    if (request.isAuthTokenRequired) {
      headers['authorization'] = this.authToken;
    }

    /** append the header params  */
    if (request.headerParams) {
      request.headerParams.map((param: any) => {
        headers[param.key] = param.value;
      });
    }

    let httpOpts: { headers: HttpHeaders; observe: any; responseType: 'blob' } =
    {
      headers: new HttpHeaders(headers),
      responseType: 'blob',
      observe: 'response',
    };
    requestURL = encodeURI(requestURL);


    try {
      if (this._commonService.isHybrid() && this.mobileService.doEnableSecureHTTP) {
        return this.secureFileDownload(requestURL, "GET", request.body, headers, "document.pdf");
      } else {
        switch (request.method) {
          case 'POST':
            return this.httpClient.post(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'GET':
            return this.httpClient.get(requestURL, httpOpts);
          case 'PUT':
            return this.httpClient.put(requestURL, request.body, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          case 'DELETE':
            return this.httpClient.delete(requestURL, httpOpts).pipe(map(
              res => { this._commonService.hideSpinner(); return res; }
            ));
          default:
            return throwError('METHOD NOT DEFINED');
        }
      }
    } catch (error) {
      return throwError(error);
    }
  }

  get authToken(): string {
    // return this._userService.getToken();
    return sessionStorage.getItem('access_token') && sessionStorage.getItem('access_token') != 'undefined' ? 'Bearer ' + sessionStorage.getItem('access_token') : "";
  }

  private _getConfig() {
    let origin = '';
    const url = origin + 'assets/config/config.json';
    return this.httpClient.get(url).subscribe((res) => {
      this._refreshVar(res);
    });
  }

  private _refreshVar(data: any) {
    this.fileUploadURL = data.fileUploadURL;
    this.keycloakURL = data.KEYCLOAK_URL;
    this.realm = data.KEYCLOAK_REALM;
    this.client = data.KEYCLOAK_CLIENT_ID;
    this.restURL = data.baseURL;

    if (data.idleTimeoutInMin)
      this.idleTimeout = parseInt(data.idleTimeoutInMin) * 60;
    else this.idleTimeout = this.defaultIdleTimeout * 60;

    if (data.idleTimeoutPromptB4Sec)
      this.promptIdleTimeoutB4 = parseInt(data.idleTimeoutPromptB4Sec);
    else this.promptIdleTimeoutB4 = 60;

    this._clearTimer();
  }

  private _clearTimer() {
    this.isPromptTimerAlert = false;
    if (this.idleTimer) clearInterval(this.idleTimer);
  }

  getBaseURL() {
    return environment.baseURL;
  }
  getDefaultContext() {
    return environment.defaultPublisher;
  }

  /**
   * Send secure http request... 
   * Which makes native network call to avoid intercept
   */
  sendSecureHTTPRequest(url: string, method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH", params: any = {}, headers, isMultipart:boolean = false): Observable<any> {
    if(isMultipart) this.secureHTTP.setDataSerializer("multipart");
    else this.secureHTTP.setDataSerializer("json");

    let secureHTTPResponse;
    if (method == "GET") {
      secureHTTPResponse = this.secureHTTP.get(url, params, headers);
    } else if (method == "POST") {
      secureHTTPResponse = this.secureHTTP.post(url, params, headers);
    } else if (method == "PUT") {
      secureHTTPResponse = this.secureHTTP.put(url, params, headers);
    } else if (method == "DELETE") {
      secureHTTPResponse = this.secureHTTP.delete(url, params, headers);
    } else if (method == "PATCH") {
      secureHTTPResponse = this.secureHTTP.patch(url, params, headers);
    }

    return from(secureHTTPResponse).pipe(
      map((response) => {
        let newRes = {};
        //TODO: to check 401
        if(response["status"] == 401){
          
        }
        newRes["body"] = response["data"] ? JSON.parse(response["data"]) : "";
        newRes["status"] = response["status"] ? response["status"] : "";
        return newRes;
      }),
      catchError(reason => {
        console.log("SSL Error Status: ", reason.status);
        console.log("SSL Error Message: ", reason.error);
        let newRes = {};
        if(reason.status == -2){
          this._commonService.showVersionUpdateAlert('sslInValid', 'Update Required', "This app will not work. A new version is available, please update to continue using the app.", ['Update'], 'alert');
        } else {
          newRes["error"] = reason["error"] ? JSON.parse(reason["error"]) : "";
          newRes["status"] = reason["status"] ? reason["status"] : "";
        }
        return throwError(newRes);
      })
    );
  }

  secureFileDownload(url: string, method: "GET" | "POST" | "PUT" | "DELETE", params: any = {}, headers, fileName: string): Observable<any> {
    var filePath = "";
    switch (this.mobileService.device.platform) {
      case "Android":
        filePath = cordova.file.externalDataDirectory + fileName;
        break;
      case "iOS":
        filePath = cordova.file.documentsDirectory + fileName;
        break;
    }

    this._commonService.showSpinner();

    return from(this.secureHTTP.downloadFile(url, params, headers, filePath)).pipe(
      map((res) => { 
          this._commonService.hideSpinner();
          return res; 
        }
      )
    );
  }

}
